import { MAX_GRID_WIDTH } from "config/styleConsts";
import { TrustedBrands } from "modules/common/components/PressLogos/";
import RichtextAdapter from "modules/storyblok/adapters/RichtextAdapter";
import useDeviceSize from "hooks/useDeviceSize";
import { Button } from "modules/storyblok/adapters";
import {
  ChakraFlex as Flex,
  ChakraGrid as Grid,
  ChakraBox as Box,
  ChakraHeading as Heading,
  ChakraImage as Image,
  ChakraSimpleGrid as SimpleGrid,
} from "@airhelp/react-ui-components";
import { TrustpilotExtended } from "../Trustpilot";
import type { AboveTheFoldCTAProps } from "./AboveTheFoldCTA.d";
import { textStyles } from "./AboveTheFoldCTA.styles";

export const AboveTheFoldCTA = ({
  title,
  subtitle,
  srcDesktop,
  srcMobile,
  alt,
  trustpilot,
  buttons = [],
}: AboveTheFoldCTAProps) => {
  const { isTablet } = useDeviceSize();

  const src = (isTablet ? srcMobile : srcDesktop) || srcDesktop;
  return (
    <Box py={{ base: 12, lg: 8 }} maxW={MAX_GRID_WIDTH} px={{ base: 4, lg: 8 }} mx="auto">
      <SimpleGrid
        templateColumns={{ base: "1fr", lg: "50% 46%" }}
        pb={{ base: 8, lg: 0 }}
        gap={6}
        justifyContent="space-between"
      >
        <Flex direction="column" justify="space-between">
          <Flex
            align={{ base: "center", lg: "flex-start" }}
            direction="column"
            mt={{ base: 0, lg: 10 }}
            textAlign={{ base: "center", lg: "start" }}
          >
            <TrustpilotExtended trustpilotVariant={trustpilot} />
            <Heading variant="h1" color="primary.900" mt={{ base: 6, lg: 4 }} px={{ base: 0, md: 4, lg: 0 }}>
              {title}
            </Heading>
            <RichtextAdapter content={subtitle} customStyles={textStyles} />
            <Grid
              templateColumns={{ base: "minmax(0, 1fr)", md: "repeat(3, minmax(0, 1fr))" }}
              columnGap={{ md: 4, lg: 3, xl: 4 }}
              rowGap={2}
              width={{ base: "100%", md: "unset" }}
              my={6}
            >
              {buttons.map(({ ...button }) => (
                <Button key={button._uid} blok={button} />
              ))}
            </Grid>
          </Flex>
          <Box pb={{ base: 6, lg: 0 }}>
            <TrustedBrands />
          </Box>
        </Flex>
        <Flex width="100%" height={{ base: 80, lg: "100%" }} maxHeight={{ lg: "530px" }} margin="auto">
          {src && <Image src={src} alt={alt} borderRadius="xl" width="100%" objectFit="cover" />}
        </Flex>
      </SimpleGrid>
    </Box>
  );
};
